import { PathReport } from '@/types';

/**
 * Deduplicates an array of PathReport objects based on their essential properties.
 * This prevents duplicate paths from being displayed when the API returns redundant results.
 *
 * @param paths - Array of PathReport objects to deduplicate
 * @returns Deduplicated array of PathReport objects
 */
export function deduplicatePaths(paths: PathReport[]): PathReport[] {
  return paths.reduce((acc: PathReport[], path: PathReport) => {
    // Create a unique key for each path based on its essential properties
    const pathKey = JSON.stringify({
      r_point_id: path.r_point_id,
      d_point_id: path.d_point_id,
      node_tuples: path.node_tuples,
      contract_list: [... (path.contract_list ?? [])]?.sort(),
      profit: path.profit,
      max_volume: path.max_volume,
    });

    // Only add if we haven't seen this exact path before
    const isDuplicate = acc.some((existing: PathReport) => {
      const existingKey = JSON.stringify({
        r_point_id: existing.r_point_id,
        d_point_id: existing.d_point_id,
        node_tuples: existing.node_tuples,
        contract_list: [... (existing.contract_list ?? [])]?.sort(),
        profit: existing.profit,
        max_volume: existing.max_volume,
      });
      return existingKey === pathKey;
    });

    if (!isDuplicate) {
      acc.push(path);
    }

    return acc;
  }, []);
}
